<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <b-button pill size="sm" v-b-modal.modal-certificate>Create Certificate</b-button>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="accountData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'btn'">
                      <div class="p-1">
                        <b-button pill size="sm" v-b-modal.modal-certificate @click="setModalCertificateData(props.row, 'edit')">Edit Certificate</b-button>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>


            <b-modal id="modal-certificate" size="lg" title="Certificate" button-size="sm">
              <label>Certificate Code:</label>
              <b-form-input type="text" v-model="certificate.certificate_code" placeholder="Input Certificate Code"></b-form-input>
              <label>Event Name:</label>
              <b-form-input type="text" v-model="certificate.event_name" placeholder="Input Event Name"></b-form-input>
              <label>Full Name:</label>
              <b-form-input type="text" v-model="certificate.other_data.full_name" placeholder="Input Full Name"></b-form-input>
              <label>Institution Name:</label>
              <b-form-input type="text" v-model="certificate.other_data.institution_name" placeholder="Input Institution Name"></b-form-input>
              <label>Participant Status:</label>
              <b-form-select v-model="certificate.other_data.participant_status" :options="participantOptions"></b-form-select>
              <label>Event Date:</label>
              <b-form-datepicker v-model="certificate.completed_date" class="mb-2" placeholder="Input Tanggal Pelaksanaan" locale="id"></b-form-datepicker>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button v-if="mode === 'create'" variant="primary" :disabled="loadingUpdate" size="sm" @click="createCertificate">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Submit
                  </div>
                </b-button>
                <b-button v-else variant="primary" :disabled="loadingUpdate" size="sm" @click="updateCertificate">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Submit
                  </div>
                </b-button>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";
export default {
  name: "ping-guru",
  page: {
    title: "Ping Guru",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchCertificateData()
  },
  data() {
    return {
      title: "Pundi",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        name: '',
      },
      accountData: [],
      columns: [
        { field: "certificate_code", label: "Certificate Code" },
        { field: "event_name", label: "Event Name" },
        { field: "completed_date", label: "Event Date" },
        { field: "account.name", label: "Full Name" },
        { field: "account.institution_name", label: "Institution Name" },
        { field: "account.participant_status", label: "Participant Status" },
        { field: "btn", label: "#" },
      ],
      exportLoading: false,
      certificate: {
        certificate_code: '',
        completed_date: '',
        certificate_type: 'pundi',
        event_name: '',
        other_data: {
          institution_name: '',
          full_name: '',
          participant_status: 'instructor',
        }
      },
      loadingUpdate: false,
      mode: 'create',
      participantOptions: [
        { value: 'instructor', text: 'Instructor' },
        { value: 'member', text: 'Member' },
      ]
    }
  },
  computed: {


  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchCertificateData() {
      let params = queryString.stringify({
        ...{
          name: null,
          certificate_type: 'pundi',
        }
        , ...this.getArguments}
      )
      this.httpCallCertificateData(params)
    },
    httpCallCertificateData(params) {
      axios.get("/api/certificate?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.accountData = data
            this.isFetched = true
          });
    },
    setModalCertificateData(rowData, mode = 'create') {
      if (mode !== 'create') {
        const certificateData = rowData
        this.certificate = certificateData
        this.certificate.other_data = {
          institution_name: certificateData.account.institution_name,
          full_name: certificateData.account.name,
          participant_status: certificateData.account.participant_status,
        }
      } else {
        this.certificate = {
          certificate_code: '',
          completed_date: '',
          certificate_type: 'pundi',
          event_name: '',
          other_data: {
            institution_name: '',
            full_name: '',
            participant_status: 'instructor',
          }
        }
      }
      this.mode = mode
    },
    createCertificate() {
      const validate = this.validateCertificate()
      if (validate.length > 0) {
        this.raiseValidationError(validate)
        return
      }

      this.loadingUpdate = true
      axios.post("/api/certificate", this.certificate)
          .then(resp => {
            this.loadingUpdate = false
            Swal.fire('Success')
            this.$bvModal.hide('modal-certificate')
            this.fetchCertificateData()
          }).catch(() => {
        this.loadingUpdate = false
        Swal.fire("Failed to process", "", "error")
      })
    },
    updateCertificate() {
      const validate = this.validateCertificate()
      if (validate.length > 0) {
        this.raiseValidationError(validate)
        return
      }

      this.loadingUpdate = true
      axios.put("/api/certificate/"+this.certificate.id, this.certificate)
          .then(resp => {
            this.loadingUpdate = false
            Swal.fire('Success')
            this.$bvModal.hide('modal-certificate')
            this.fetchCertificateData()
          }).catch(() => {
        this.loadingUpdate = false
        Swal.fire("Failed to process", "", "error")
      })
    },
    validateCertificate() {
      const payload = this.certificate
      let result = []
      if (payload.certificate_code === '') {
        result.push('code')
      }
      if (payload.completed_date === '') {
        result.push('event_date')
      }

      return result
    },
    raiseValidationError(field) {
      const tagLi = field.map(x => '<li>Field '+ x.toUpperCase() +' belum diisi</li>').join('')
      Swal.fire({
        title: '',
        icon: 'error',
        html:
            `
            <b>Mohon isi data</b>
            <ul style="list-style-type:disc; text-align:left">
                ${tagLi}
            </ul>`,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText:
            'OK',
      })
    },
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        name: value,
        sort: '-id',
      })
      this.httpCallCertificateData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallCertificateData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallCertificateData(params)
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>